var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"del-wrap"},[_vm._t("default"),(_vm.showClose)?_c('div',{staticClass:"icon-close",on:{"click":function($event){$event.stopPropagation();return _vm.handleClose.apply(null, arguments)}}},[_c('i',{staticClass:"el-icon-close"})]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }